import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        // ===============================================
        // Landingpage
        // ===============================================
        case 'godt-at-vide':
            nextPage = 'ansoegning';
            break;

        // ===============================================
        // Om ansøgeren
        // ===============================================
        case 'ansoegning':
            if (getValueOrDefault(formConfig, formValues, 'fillingOnBehalfOfSomeoneElse').value === 'yes') {
                nextPage = 'ansoegning-paa-vegne-af';
            } else {
                nextPage = 'hvorfor-ansoeger-du';
            }
            break;
        case 'ansoegning-paa-vegne-af':
            nextPage = 'hvorfor-ansoeger-du';
            break;

        // ===============================================
        // Om rejsen
        // ===============================================
        case 'hvorfor-ansoeger-du':
            nextPage = 'hvilke-lande';
            break;
        case 'hvilke-lande':
            nextPage = 'dato-for-rejsen';
            break;
        case 'dato-for-rejsen':
            nextPage = 'privat-eller-erhvervsrejse';
            break;
        case 'privat-eller-erhvervsrejse':
            nextPage = 'rejsens-pris';

            if (getValueOrDefault(formConfig, formValues, 'privateOrBusinessTravel').value === 'business') {
                nextPage = 'om-virksomheden';
            }

            break;

        case 'om-virksomheden':
            nextPage = 'rejsens-pris';
            break;

        case 'rejsens-pris':
            nextPage = 'rejse-type';
            break;
        case 'rejse-type':
            nextPage = 'aarsag-til-forhaandsvurdering';

            if (getValueOrDefault(formConfig, formValues, 'travelPurpose').value === 'yes') {
                nextPage = 'hvilke-aktiviteter';
            }

            break;

        case 'hvilke-aktiviteter':
            nextPage = 'aarsag-til-forhaandsvurdering';
            break;

        // ===============================================
        // Om sygdommen
        // ===============================================
        case 'aarsag-til-forhaandsvurdering':
            nextPage = 'kronisk-sygdom';
            break;
        case 'kronisk-sygdom':
            nextPage = 'behandling-seneste-to-maaneder';

            if (getValueOrDefault(formConfig, formValues, 'doYouHaveChronicDiseases').value === 'yes') {
                nextPage = 'kronisk-sygdom-beskrivelse';
            }

            break;

        case 'kronisk-sygdom-beskrivelse':
            nextPage = 'behandling-seneste-to-maaneder';
            break;

        case 'behandling-seneste-to-maaneder':
            nextPage = 'dato-for-behandling';

            if (
                getValueOrDefault(formConfig, formValues, 'haveYouConsultedADoctorWithinTheLatestTwoMonths').value ===
                'no'
            ) {
                nextPage = 'laegeordineret-medicin';
            }

            break;
        case 'dato-for-behandling':
            nextPage = 'behandlingstype';
            break;
        case 'behandlingstype':
            nextPage = 'laegeordineret-medicin';
            break;

        case 'laegeordineret-medicin':
            nextPage = 'om-medicinen';

            if (
                getValueOrDefault(formConfig, formValues, 'areYouInTreatmentWithDoctorsOrderedMedicine').value === 'no'
            ) {
                nextPage = 'symptomer-seneste-to-uger';
            }

            break;

        case 'om-medicinen':
            nextPage = 'aendring-i-medicin';
            break;
        case 'aendring-i-medicin':
            nextPage = 'om-medicin-ændringen';

            if (
                getValueOrDefault(formConfig, formValues, 'haveYouHadYourMedicationChangedWithinTheLastTwoMonths')
                    .value === 'no'
            ) {
                nextPage = 'symptomer-seneste-to-uger';
            }

            break;
        case 'om-medicin-ændringen':
            nextPage = 'symptomer-seneste-to-uger';
            break;

        case 'symptomer-seneste-to-uger':
            nextPage = 'beskriv-symptomerne';

            if (getValueOrDefault(formConfig, formValues, 'haveYouHadSymptomsWithinTheLast14Days').value === 'no') {
                nextPage = 'indlaeggelse-seneste-to-maaneder';
            }

            break;
        case 'beskriv-symptomerne':
            nextPage = 'indlaeggelse-seneste-to-maaneder';
            break;

        case 'indlaeggelse-seneste-to-maaneder':
            nextPage = 'dato-for-indlaeggelse';

            if (
                getValueOrDefault(formConfig, formValues, 'haveYouBeenSubmittedToHospitalWithTheLastTwoMonths')
                    .value === 'no'
            ) {
                nextPage = 'afventer-du-behandling';
            }

            break;
        case 'dato-for-indlaeggelse':
            nextPage = 'afventer-du-behandling';
            break;
        case 'afventer-du-behandling':
            nextPage = 'hvilken-behandling';

            if (getValueOrDefault(formConfig, formValues, 'areYouAwaitingTreatment').value === 'no') {
                nextPage = 'tilskadekomst-seneste-to-maaneder';
            }

            break;
        case 'hvilken-behandling':
            nextPage = 'tilskadekomst-seneste-to-maaneder';
            break;

        // ===============================================
        // Om tilskadekomst
        // ===============================================
        case 'tilskadekomst-seneste-to-maaneder':
            nextPage = 'beskriv-tilskadekomsten';

            if (getValueOrDefault(formConfig, formValues, 'haveYouBeenInjuredWithinTheLastTwoMonths').value === 'no') {
                nextPage = 'korrekte-oplysninger';
            }

            break;
        case 'beskriv-tilskadekomsten':
            nextPage = 'dato-for-tilskadekomsten';
            break;
        case 'dato-for-tilskadekomsten':
            nextPage = 'behandlingen-for-tilskadekomsten';
            break;
        case 'behandlingen-for-tilskadekomsten':
            nextPage = 'symptomer-seneste-to-uger-2';
            break;
        case 'symptomer-seneste-to-uger-2':
            nextPage = 'beskriv-symptomerne-2';

            if (getValueOrDefault(formConfig, formValues, 'injurySymptomsWithin14Days').value === 'no') {
                nextPage = 'afventer-du-behandling-2';
            }

            break;
        case 'beskriv-symptomerne-2':
            nextPage = 'afventer-du-behandling-2';
            break;
        case 'afventer-du-behandling-2':
            nextPage = 'hvilken-behandling-2';

            if (getValueOrDefault(formConfig, formValues, 'waitingForTreatment').value === 'no') {
                nextPage = 'korrekte-oplysninger';
            }

            break;
        case 'hvilken-behandling-2':
            nextPage = 'korrekte-oplysninger';
            break;

        // ===============================================
        // Om dig
        // ===============================================
        case 'korrekte-oplysninger':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;

        // ===============================================
        // Summery
        // ===============================================
        case 'resume':
            nextPage = undefined;
            break;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
